import { cpuUsage } from "process";
import { isTruthyComparison } from "../../pb-screen/filters/advanced.filter.comparison";
import { PoolContainer } from "../../pool/models/pool-containers.interface";
import { PoolMove } from "../../pool/models/pool-move.interface";
import { AdvancedFilterOperatorType, AdvancedFilterColumnType } from "../../shared/components/filter-line/filter-line.interface";
import { transformColumnNamesToProperties } from "../../static/columName.to.property.transformation";


const columnNames = [
  { title: "COLUMN_SELECTION.COLUMN_NAMES.containerNo", field: "containerNo" },
  { title: "COLUMN_SELECTION.COLUMN_NAMES.containerType", field: "containerType" },
  { title: "SHARED.COLUMN_NAMES.CARRIER.NAME", field: "carrierName" },
  { title: "SHARED.COLUMN_NAMES.STATUS", field: "status" },
  { title: "SHARED.COLUMN_NAMES.LOCATION", field: "location" },
  { title: "SHARED.COLUMN_NAMES.POOL.ADDRESS_NAME", field: "poolAddressSearchName" },
  { title: "SHARED.COLUMN_NAMES.COMMENT", field: "comment" }
];


const MovesColumnNames = [
  { title: "COLUMN_SELECTION.COLUMN_NAMES.containerNo", field: "containerNo" },
  { title: "SHARED.COLUMN_NAMES.ANNOUNCED_NUMBER", field: "announced" },
  { title: "COLUMN_SELECTION.COLUMN_NAMES.containerType", field: "containerType" },
  { title: "SHARED.COLUMN_NAMES.HAULIER_NAME", field: "haulierName" },
  { title: "SHARED.COLUMN_NAMES.TRUCK_REGISTRATION_NUMBER", field: "truckRegistrationNo" },
  { title: "SHARED.COLUMN_NAMES.DRIVER_NAME", field: "driverName" },
  { title: "SHARED.COLUMN_NAMES.CARRIER_CODE", field: "carrierCode" },
  { title: "SHARED.COLUMN_NAMES.TO_LOCATION", field: "toLocation" },
  { title: "SHARED.COLUMN_NAMES.COMMENT", field: "comment" }
];


export function getFilteredContainersBySearchText(containers: PoolContainer[],
    searchText: string): PoolContainer[] {
    const matches: PoolContainer[] = [];
    const columNames: string[] = transformColumnNamesToProperties(columnNames.map((x) => x.field));
    const splitSearchText: string[] = searchText.split(" ");
    const filteredSplitSearchText: string[] = splitSearchText.filter(t => t.length > 0);

    for (let container of containers) {
        let matchedAllStrings: boolean = true;
        for (let text of filteredSplitSearchText) {
            let isValidFilterOperation: boolean = false;
            for (let column of columNames) {
                if (isTruthyComparison(container[column],
                    AdvancedFilterOperatorType.Contains,
                    text,
                    AdvancedFilterColumnType.Text)) {
                    isValidFilterOperation = true;
                }
            }
            if (!isValidFilterOperation) {
                matchedAllStrings = false;
                break;
            }
        }

        if (matchedAllStrings) {
            matches.push(container);
        }
    }
    return matches;
}

export function getFilteredPreAnnouncedMovesBySearchText(moves : PoolMove[] , searchText : string) : PoolMove[]
{
    const matches : PoolMove[] = [];
    const columNames : string[] = transformColumnNamesToProperties(MovesColumnNames.map((x) => x.field));

    const splitSearchText: string[] = searchText.split(" ");
    const filteredSplitSearchText: string[] = splitSearchText.filter(t => t.length > 0);

    for (let move of moves) {
        let matchedAllStrings: boolean = true;
        for (let text of filteredSplitSearchText) {
            let isValidFilterOperation: boolean = false;
            for (let column of columNames) {
                if (isTruthyComparison(move[column],
                    AdvancedFilterOperatorType.Contains,
                    text,
                    AdvancedFilterColumnType.Text)) {
                    isValidFilterOperation = true;
                }
            }
            if (!isValidFilterOperation) {
                matchedAllStrings = false;
                break;
            }
        }

        if (matchedAllStrings) {
            matches.push(move);
        }
    }
    return matches;
}

export function getFilteredAnnouncedContainers(containers: PoolContainer[] , searchText: string) : PoolContainer[] {
    const matches: PoolContainer[] = [];
    const columNames: string[] = transformColumnNamesToProperties(columnNames.map((x) => x.field));
    const splitSearchText: string[] = searchText.split(" ");
    const filteredSplitSearchText: string[] = splitSearchText.filter(t => t.length > 0);

    for (let container of containers) {
        let matchedAllStrings: boolean = true;
        for (let text of filteredSplitSearchText) {
            let isValidFilterOperation: boolean = false;
            for (let column of columNames) {
                if (isTruthyComparison(container[column],
                    AdvancedFilterOperatorType.Contains,
                    text,
                    AdvancedFilterColumnType.Text)) {
                    isValidFilterOperation = true;
                }
            }
            if (!isValidFilterOperation) {
                matchedAllStrings = false;
                break;
            }
        }

        if (matchedAllStrings) {
            matches.push(container);
        }
    }
    return matches;
}
